// "use client";

// import React from "react";
// import { motion } from "framer-motion";
// import { 
//   FiShield, FiInfo, FiLock, FiExternalLink, FiUserCheck, 
//   FiFileText, FiShieldOff, FiRefreshCw, FiEye, FiDatabase, FiSmartphone 
// } from "react-icons/fi";

// const PrivacyPolicy = () => {
//   const sections = [
//     {
//       id: "1",
//       title: "1. Information We Collect",
//       icon: <FiEye className="text-blue-500" />,
//       content: (
//         <div className="space-y-4">
//           <div>
//             <h4 className="text-white font-semibold mb-2">1.1 Personal Information</h4>
//             <p>We may collect personal information that you voluntarily provide, including but not limited to:</p>
//             <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-3 ml-4 list-disc text-slate-400">
//               <li>Full name</li>
//               <li>Email address</li>
//               <li>Phone number</li>
//               <li>City and address</li>
//               <li>Login credentials</li>
//               <li>Job application details (CVs, LinkedIn)</li>
//               <li>Business or service inquiries</li>
//             </ul>
//           </div>
//           <div className="pt-2">
//             <h4 className="text-white font-semibold mb-2">1.2 Automatically Collected Information</h4>
//             <p>When you access our website, we may automatically collect certain technical information such as:</p>
//             <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-3 ml-4 list-disc text-slate-400">
//               <li>IP address</li>
//               <li>Browser type and version</li>
//               <li>Device and operating system</li>
//               <li>Pages viewed & session duration</li>
//             </ul>
//           </div>
//         </div>
//       ),
//     },
//     {
//       id: "2",
//       title: "2. Purpose of Data Collection",
//       icon: <FiDatabase className="text-purple-500" />,
//       content: (
//         <div className="space-y-2">
//           <p>We process personal data for legitimate business purposes, including:</p>
//           <ul className="space-y-2 mt-3 ml-4 list-disc text-slate-400">
//             <li>Providing and managing our software solutions and services</li>
//             <li>User authentication and secure login access</li>
//             <li>Responding to inquiries, support requests, and communications</li>
//             <li>Recruitment and employment evaluation</li>
//             <li>Improving website functionality, performance, and user experience</li>
//             <li>Analytics, reporting, and business insights</li>
//             <li>Compliance with legal and regulatory obligations</li>
//           </ul>
//         </div>
//       ),
//     },
//     {
//       id: "3",
//       title: "3. Cookies and Tracking Technologies",
//       icon: <FiSmartphone className="text-emerald-500" />,
//       content: "We use cookies and similar technologies to enhance website performance, analyze traffic, and improve user experience. You may control or disable cookies through your browser settings; however, certain website features may not function correctly if cookies are disabled.",
//     },
//     {
//       id: "4",
//       title: "4. Third-Party Services",
//       icon: <FiExternalLink className="text-orange-500" />,
//       content: "NubitSoft may engage trusted third-party service providers such as analytics platforms, hosting services, and communication tools. These providers process data in accordance with their own privacy policies and contractual obligations. We do not control and are not responsible for third-party privacy practices.",
//     },
//     {
//       id: "5",
//       title: "5. Data Sharing and Disclosure",
//       icon: <FiInfo className="text-cyan-500" />,
//       content: (
//         <div>
//           <p>We do not sell, rent, or trade personal data. Information may only be disclosed:</p>
//           <ul className="mt-3 space-y-2 ml-4 list-disc text-slate-400">
//             <li>To comply with legal requirements or lawful requests</li>
//             <li>To protect the rights, property, or safety of NubitSoft and its users</li>
//             <li>To authorized service providers under strict confidentiality agreements</li>
//           </ul>
//         </div>
//       ),
//     },
//     {
//       id: "6",
//       title: "6. Data Security",
//       icon: <FiLock className="text-red-500" />,
//       content: "We implement appropriate administrative, technical, and physical safeguards to protect personal data against unauthorized access, disclosure, alteration, or destruction. While we strive to use commercially acceptable means to protect information, no internet-based system is completely secure.",
//     },
//     {
//       id: "7",
//       title: "7. User Accounts and Login Security",
//       icon: <FiUserCheck className="text-blue-400" />,
//       content: "Users are responsible for maintaining the confidentiality of their account credentials. Any activity conducted through a registered account is the responsibility of the account holder.",
//     },
//     {
//       id: "8",
//       title: "8. Career Applications",
//       icon: <FiFileText className="text-yellow-500" />,
//       content: "Personal data submitted through career and recruitment forms is used strictly for hiring, evaluation, and internal HR processes. Such data is accessed only by authorized personnel.",
//     },
//     {
//       id: "9",
//       title: "9. Children’s Privacy",
//       icon: <FiShieldOff className="text-pink-500" />,
//       content: "Our services are not intended for individuals under the age of 13. We do not knowingly collect personal data from children. Any such data identified will be promptly deleted.",
//     },
//     {
//       id: "10",
//       title: "10. Your Data Protection Rights",
//       icon: <FiShield className="text-indigo-500" />,
//       content: (
//         <div>
//           <p>Subject to applicable laws, you have the right to:</p>
//           <ul className="mt-3 space-y-2 ml-4 list-disc text-slate-400">
//             <li>Access your personal data</li>
//             <li>Request correction or deletion</li>
//             <li>Restrict or object to processing</li>
//             <li>Withdraw consent where applicable</li>
//           </ul>
//         </div>
//       ),
//     },
//     {
//       id: "11",
//       title: "11. Policy Updates",
//       icon: <FiRefreshCw className="text-teal-500" />,
//       content: "NubitSoft reserves the right to update this Privacy Policy at any time. Updates will be posted on this page and will take effect immediately.",
//     },
//   ];

//   return (
//     <div className="bg-[#0a0a0a] min-h-screen text-slate-300 font-sans selection:bg-blue-500/30">
//       {/* Background Glow Effect */}
//       <div className="fixed top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none">
//         <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-blue-900/10 blur-[120px] rounded-full" />
//         <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-purple-900/10 blur-[120px] rounded-full" />
//       </div>

//       <div className="max-w-5xl mx-auto px-6 py-24">
//         {/* Header Section */}
//         <motion.div 
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           className="text-center mb-20"
//         >
//           <h1 className="text-5xl md:text-7xl font-bold text-white my-6 tracking-tight">
//             Privacy <span className="bg-gradient-to-r from-blue-500 to-cyan-400 bg-clip-text text-transparent">Policy</span>
//           </h1>
//           <div className="flex flex-col items-center gap-2">
//             <p className="text-xl text-slate-400 max-w-2xl mx-auto leading-relaxed">
//               Nubit Software Pvt. Ltd. is committed to protecting the privacy of visitors and users of 
//               <span className="text-blue-400 ml-1 font-medium underline underline-offset-4">nubitsoft.com</span>
//             </p>
//             <div className="mt-6 px-4 py-1 bg-slate-900 border border-slate-800 rounded-full text-sm font-mono text-slate-500">
//               Effective Date: January 2026
//             </div>
//           </div>
//         </motion.div>

//         {/* Introduction Card */}
//         <motion.div 
//           initial={{ opacity: 0 }}
//           whileInView={{ opacity: 1 }}
//           viewport={{ once: true }}
//           className="bg-gradient-to-br from-slate-900/80 to-slate-950 border border-slate-800 p-8 rounded-3xl mb-16 shadow-2xl backdrop-blur-md"
//         >
//           <p className="text-lg leading-relaxed text-slate-300">
//             This Privacy Policy explains how we collect, use, store, and protect your information in accordance with applicable data protection laws and industry best practices.
//           </p>
//         </motion.div>

//         {/* Content Grid */}
//         <div className="grid gap-8">
//           {sections.map((section, index) => (
//             <motion.div
//               key={section.id}
//               initial={{ opacity: 0, y: 30 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               transition={{ delay: index * 0.05 }}
//               className="group relative bg-slate-900/30 border border-slate-800 hover:border-slate-700/50 p-8 rounded-2xl transition-all duration-300"
//             >
//               <div className="flex items-start gap-6">
//                 <div className="flex-shrink-0 w-12 h-12 bg-slate-900 border border-slate-800 rounded-xl flex items-center justify-center text-2xl shadow-inner group-hover:scale-110 transition-transform duration-300">
//                   {section.icon}
//                 </div>
//                 <div className="flex-1">
//                   <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-blue-400 transition-colors">
//                     {section.title}
//                   </h3>
//                   <div className="text-slate-400 leading-relaxed text-base md:text-lg">
//                     {section.content}
//                   </div>
//                 </div>
//               </div>
//             </motion.div>
//           ))}
//         </div>

//         {/* Contact Footer */}
//         <motion.div 
//           initial={{ opacity: 0 }}
//           whileInView={{ opacity: 1 }}
//           className="mt-20 p-12 rounded-3xl bg-blue-600/5 border border-blue-500/20 text-center"
//         >
//           <h2 className="text-3xl font-bold text-white mb-4">Have Questions?</h2>
//           <p className="text-slate-400 mb-8 max-w-md mx-auto">
//             If you have any concerns regarding your data privacy, feel free to reach out to our legal team.
//           </p>
//           <a 
//             href="mailto:info@nubitsoft.com" 
//             className="inline-flex items-center justify-center px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-full transition-all shadow-lg shadow-blue-900/20 active:scale-95"
//           >
//             Contact NubitSoft Team
//           </a>
//         </motion.div>
//       </div>
//     </div>
//   );
// };

// export default PrivacyPolicy;

'use client';

import { motion } from "framer-motion";
import PrivacyAccordion from "@/components/PrivacyPolicy/PrivacyAccordion";
import Image from "next/image";

export default function PrivacyPolicyPage() {
  return (
    <main className="bg-[#0B0F19] text-gray-200 min-h-screen">

      {/* Hero */}
      <section className="relative overflow-hidden border-b border-gray-800 bg-gradient-to-br from-[#0B0F19] via-[#0E1529] to-[#141B2D]">

        {/* Subtle Glow */}
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl" />
        <div className="absolute top-1/3 -right-24 w-96 h-96 bg-purple-600/20 rounded-full blur-3xl" />

        <div className="relative max-w-7xl mx-auto px-6 py-32 grid md:grid-cols-2 gap-14 items-center">

          {/* Left Content */}
          <div className="space-y-6 max-w-xl">

            {/* Badge */}
            <span className="inline-flex items-center rounded-full border border-blue-500/30 bg-blue-500/10 px-4 py-1 text-sm text-blue-400">
              Legal & Compliance
            </span>

            <h1 className="text-4xl md:text-5xl xl:text-6xl font-bold text-white leading-tight">
              Privacy Policy
            </h1>

            <p className="text-gray-400">
              <span className="font-medium text-gray-300">
                Nubit Software Pvt. Ltd.
              </span>{" "}
              • Effective Date: January 2026
            </p>

            <p className="text-gray-400 leading-relaxed">
              <strong className="text-gray-300">Nubit Software Pvt. Ltd.</strong>{" "}
              (“NubitSoft”, “we”, “our”, or “us”) is committed to protecting the
              privacy and personal data of visitors, users, clients, and partners
              who access or use our website {" "}
              <span className="text-blue-400">https://nubitsoft.com</span>.
            </p>

            <p className="text-gray-400 leading-relaxed">
              This Privacy Policy explains how we collect, use, store, and protect
              your information in accordance with applicable data protection laws
              and industry best practices.
            </p>
          </div>

          {/* Right Illustration */}
          <div className="flex justify-center items-center mt-10 md:mt-4">
            <div
              className="relative w-full max-w-[420px] md:max-w-[460px] lg:max-w-[520px]
           h-[260px] sm:h-[300px] md:h-[340px] lg:h-[380px]
           rounded-2xl border border-gray-700/80
           bg-gradient-to-br from-blue-600/10 to-purple-600/10 
           backdrop-blur-xl
           shadow-[0_25px_70px_-20px_rgba(0,0,0,0.85)]
           flex items-center justify-center"
            >
              <Image
                src="/policy.jpg"
                alt="Privacy & Security"
                fill
                className="object-cover sm:p-6"
                priority
              />

              {/* Subtle inner highlight */}
              <div className="pointer-events-none absolute inset-0 rounded-2xl ring-1 ring-white/5" />
            </div>
          </div>

        </div>
      </section>


      {/* Content */}
      <section className="max-w-7xl mx-auto px-6 py-16 grid lg:grid-cols-3 gap-12">


        {/* Accordion */}
        <div className="lg:col-span-3">
          <PrivacyAccordion />
        </div>
      </section>
    </main>
  );
}
